import TooltipHTML from '#components/TooltipHTML/TooltipHTML.js';
import {
  replacePlainTextToLinksPattern,
  replacePlainTextToLinksTemplate,
  splitTextDescriptionHTML
} from '../../../../utils/lookahead-common';
import { sanitizeString } from '../../GanttVisualization.helper';

export const createReadOnlyContent = (task, column, t) =>
  `<div>${splitTextDescriptionHTML(task, column, t)}</div>`;

export const createPendingContent = (task, isOdd, t, gantt) => {
  const contentDescription = `<span>${task.description || '&nbsp;'}</span>`;

  const contentWithTooltip = TooltipHTML({
    text: t('activity_pending_sir_actions_tooltip'),
    container: contentDescription,
    task_id: task.id,
    name: 'description',
    gantt: gantt,
    customClass: 'TooltipHTML--pending'
  });

  return `
    <div class="${isOdd ? 'odd-col' : 'non-odd-col'}" style="cursor: not-allowed !important; color: #b3b3b3 !important; min-height: 20px;">
      ${contentWithTooltip}
    </div>
  `;
};

export const createEditableContent = (task, columnName, t, column) => {
  const description = task[columnName]
    ? sanitizeString(task[columnName]).replace(
        replacePlainTextToLinksPattern,
        replacePlainTextToLinksTemplate
      )
    : '';

  return `
    <span>${description}</span>
    <div style="cursor: pointer;">
      ${splitTextDescriptionHTML(task, column, t)}
    </div>
  `;
};
